/*
 * Moves the "Kavi video testimonials" section (rendered by
 * sections/kavi-video-testimonials.liquid, further down the page in section
 * order) into the product-media column, right after the image gallery — so it
 * sits in the same row as the accordion tabs instead of appearing as its own
 * full-width section lower on the page. Kept as a JSON section (rather than
 * being built into main-product.liquid directly) so the 3 video slots stay
 * editable as blocks in the theme editor; this script only repositions the
 * already-rendered DOM node, so the slider-component custom element inside it
 * keeps working normally (moving a connected element doesn't re-run its
 * constructor).
 */
(function () {
  function dockKaviVideoTestimonials() {
    var section = document.querySelector('.kavi-video-testimonials');
    var mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!section || !mediaWrapper) return;
    if (section.dataset.kaviDocked === 'true') return;
    section.dataset.kaviDocked = 'true';
    mediaWrapper.appendChild(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dockKaviVideoTestimonials);
  } else {
    dockKaviVideoTestimonials();
  }
})();
